"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/************************************** THIRD-PARTY MODULES ***************************************/
var mobx_1 = require("mobx");
/**************************************** PROJECT MODULES *****************************************/
var javelin_exports_1 = require("../../javelin-exports");
/******************************************** LOGGING *********************************************/
var shared_1 = require("mad-logs/lib/shared");
var log = shared_1.logFactory('dose-store.ts', shared_1.Styles.hatBlock);
var cln = "DoseStore";
/********************************************* EXPORT *********************************************/
/**
 * @export DoseStore - Store dose data
 */
var DoseStore = /** @class */ (function () {
    function DoseStore(rootStore) {
        this.rootStore = rootStore;
        /**
         * Find dose in record (record.doses)
         */
        this.findDoseIdxInObj = function (record, dose) {
            return record.doses.findIndex(function (recordDose) { return recordDose.recordId === dose.recordId && recordDose.doseId === dose.doseId; });
        };
    }
    //
    // INSTANTIATION
    //
    DoseStore.new = function (rootStore) {
        return DoseStore.Instance || new DoseStore(rootStore);
    };
    //
    // ACTIONS
    //
    /**
     * Store new dose on corresponding record if dose creation was requested. If update
     * requested, replace existing dose. Record determined by recordId field on dose.
     * @param {Dose} dose to potentially add to (or replace on) record
     * @param {string} action Action triggering this method e.g. 'CREATE', 'UPDATE', 'DELETE'
     * @return {RecordInstance[]} All stored records
     */
    DoseStore.prototype.addOrUpdateDose = function (dose, action) {
        log.info(cln + "#addOrUpdateDose ::\n     action: " + action + "\n     dose:", dose);
        // Get record the given dose is associated with
        var record = this.rootStore.records.find(function (rec) { return rec.recordId === dose.recordId; });
        log.info(cln + "#addOrUpdateDose :: record:", record);
        // Action:
        //     CREATE :: Store new dose
        //     UPDATE :: Update stored dose, or store new dose if not found
        if (action === javelin_exports_1.Action.CREATE || action === javelin_exports_1.Action.UPDATE) {
            this.addOrUpdateDoseInRecord(record, dose);
        }
        log.info(cln + "#addOrUpdateDose -[ON RETURN]-> this.doses:", record.doses);
        return record.doses;
    };
    /**
     * Delete a dose from records[].doses: Search for given dose on each record's doses
     * field, and remove it from the containing record. Removes only 1 dose in total.
     * @return {boolean} true if a dose was found and removed, false if not.
     */
    DoseStore.prototype.deleteDose = function (dose) {
        log.info(cln + "#deleteDose: del dose:", dose, "\nfrom records:", this.rootStore.records);
        var rmDose; // For logging. If a dose is removed, it gets stored here.
        // Remove dose from this.records[].doses
        for (var _i = 0, _a = this.rootStore.records; _i < _a.length; _i++) {
            var record = _a[_i];
            // Attempt to find matching dose in record, & if found, splice it out & exit loop
            var matchDoseIdx = record.doses.findIndex(function (recDose) { return dose.doseId === recDose.doseId; });
            if (matchDoseIdx !== -1) {
                rmDose = record.doses.splice(matchDoseIdx, 1);
                break;
            }
        }
        log.info(cln + "#deleteDose: rmDose:", rmDose, "\nfinal records:", this.rootStore.records);
        return !!rmDose;
    };
    //
    // HELPERS
    //
    /**
     * Update existing dose in record ({record}.doses) or add it to record if not present
     * @param {Record} record to update the doses on
     * @param {Dose} Replaces matching dose in record.doses, or adds it if not found
     */
    DoseStore.prototype.addOrUpdateDoseInRecord = function (record, dose) {
        var idx = this.findDoseIdxInObj(record, dose);
        // Replace dose in record if found
        if (idx !== -1) {
            try {
                record.doses.splice(idx, 1, dose);
                // record.doses[idx] = dose;
            }
            catch (error) {
                console.error(error, "Failed to replace dose in record:", record, "at idx:", idx);
            }
            // Add dose to record if not found
        }
        else {
            record.doses.push(dose);
        }
    };
    DoseStore.Instance = null;
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, String]),
        __metadata("design:returntype", Array)
    ], DoseStore.prototype, "addOrUpdateDose", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object]),
        __metadata("design:returntype", Boolean)
    ], DoseStore.prototype, "deleteDose", null);
    __decorate([
        mobx_1.action,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Object, Object]),
        __metadata("design:returntype", void 0)
    ], DoseStore.prototype, "addOrUpdateDoseInRecord", null);
    return DoseStore;
}());
exports.DoseStore = DoseStore;
/******************************************** FACTORY *********************************************/
/**
 * DoseStore singleton factory
 */
exports.doseStoreFactory = function (rootStore) {
    if (!DoseStore.Instance)
        DoseStore.Instance = DoseStore.new(rootStore);
    return DoseStore.Instance;
};
//# sourceMappingURL=dose-store.js.map